import React from 'react';
import PropTypes from 'prop-types';

class Achievement extends React.Component {

	render() {
		return (
			<div className="achievement">
				<img src={this.props.image}/>
				<p className="achievement-name">{this.props.name}</p>
			</div>
		);
	}

}

Achievement.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

export default Achievement;